import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCards() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-3">
            Expert Guides &amp; Articles
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-3">
            AllChinaBuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            In-depth guides covering everything from finding the best products to mastering QC photos, shipping strategies, and building your perfect wardrobe.
          </p>
        </div>

        {/* Article Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all hover:bg-background-100 cursor-pointer flex flex-col"
            >
              {/* Card Image */}
              <div className="aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={article.cardImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Card Content */}
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.cardExcerpt}
                </p>
                <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">Updated June 2026</span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-500 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    Read Article
                    <i className="ri-arrow-right-line text-[10px] group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}